export const SELECT_MODELE = "SELECT_MODELE";
export const SELECT_NODE = "SELECT_NODE";
export const REMOVE_TRACE = "REMOVE_TRACE";
export const SELECT_POSITION = "SELECT_POSITION";
export const SELECT_MOTIF = "SELECT_MOTIF";
export const STORE_CANVAS = "STORE_CANVAS";
export const STORE_IMAGE_DATA = "STORE_IMAGE_DATA";
export const COMPARE_WITH_MODEL = "COMPARE_WITH_MODEL";
export const RESET_COMPARISON = "RESET_COMPARISON";
